/* 🤖 this file was generated by svg-to-ts */
export const matIconFormatLineSpacing: {
  name: 'format-line-spacing';
  data: string;
} = {
  name: 'format-line-spacing',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z"/></svg>`
};
